import oAxiosInstance from "config/Axios";

export const apiCallGetAllLocations = () => {
  return oAxiosInstance.get("localidades");
};
